import { Container, Typography } from "@mui/material";

import { useEventHeaderStyles } from "../event/useEventHeaderStyles";
import { Breadcrumbs } from "../navigation/Breadcrumbs";
import { T } from "../../util/t";
import { makeStyles } from "../../providers/makeStyles";
import { trackingCategory } from "../../../utils/tracking";
import { LinkSponsorTags } from "../sponsors/LinkSponsorTag";

const useStyles = makeStyles(theme => ({
    sponsoredContent: {
        paddingTop: theme.spacing(1),
    }
}));
export const SchedulePageHeader = ({ event }) => {
    const classes = useEventHeaderStyles();
    const scheduleClasses = useStyles();
    const sponsoredContents = event.sponsoredContents;

    return (
        <Container>
            <div className={classes.container}>
                <Breadcrumbs
                    className="no-background"
                    crumbs={[
                        { text: event.organisation.name, link: `/${event.organisation.shortName}` },
                        { text: event.name, link: `/events/${event.id}` },
                    ]}
                />

                <Typography variant="h3" component="h1" className={classes.name}><T>Schedule</T></Typography>
                <LinkSponsorTags sponsoredContents={sponsoredContents}
                                 clickTrackingCategory={trackingCategory.sponsorIntegrationAtEvent}
                                 className={scheduleClasses.sponsoredContent}/>
            </div>
        </Container>
    );
};
